/* eslint-disable dot-notation */

export function registerEndGenerators(gen) {
  gen.forBlock['end_stop_all'] = () => `stopAll();\n`
}
